import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { retry } from 'rxjs/operator/retry';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CloneService {
  constructor(private translate: TranslateService, ) { }

  cloneIdNameOption(options: Array<IIdName>): Array<IOption> {
    return options.map(option => ({ value: option.Id, label: option.Name }));
  }

  cloneTimeZoneOption(options: Array<ITZOption>): Array<ITZOption> {
    return options.map(option => ({ value: option.value, label: option.label }));
  }


  cloneSettingsOption(options: Array<ITZOption>): Array<ITZOption> {
    return options.map(option => ({ value: option.value, label: this.translate.instant(option.label) }));
  }

  cloneModuleTitleOption(options: Array<IIdTitle>): Array<ITZOption> {
    return options.map(option => ({ value: option.Id, label: option.Title }));
  }

  cloneIdNameForUserUnitOption(options: Array<IIdNameForUnit>): Array<IOption> {
    return options.map(option => ({ value: option.Id + '-' + option.AppId, label: option.Name }));
  }
}

export interface IOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface IIdNameForUnit {
  Id: string;
  Name: string;
  AppId: string;
}

export interface IIdName {
  Id: string;
  Name: string;
}

export interface IIdTitle {
  Id: number;
  Title: string;
}

export interface ITZOption {
  value: number;
  label: string;
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/common/clone-object-management.ts